import React from 'react';
import styles from './Steps.module.css';

/**
 * 진행 단계 — "지금 어디쯤인지" 한 줄로 보여 줍니다.
 *
 * 모임 만들기 · 초대 흐름처럼 여러 화면에 걸친 과정에서 씁니다.
 * 지나온 단계와 지금 단계를 색만으로 구분하지 않고,
 * 위쪽 선 굵기와 글자 굵기로도 읽히게 했습니다.
 */

interface StepsProps {
    /** 단계 이름들 — i18n 으로 넘깁니다 */
    labels: string[];
    /** 지금 단계 (1부터) */
    current: number;
}

export const Steps = ({ labels, current }: StepsProps) => (
    <ol className={styles.steps}>
        {labels.map((label, i) => {
            const no = i + 1;
            return (
                <li
                    key={label}
                    className={[
                        styles.step,
                        no < current ? styles.done : '',
                        no === current ? styles.now : '',
                    ].filter(Boolean).join(' ')}
                    aria-current={no === current ? 'step' : undefined}
                >
                    <span className={styles.stepNo}>{no}</span>
                    <span className={styles.stepLabel}>{label}</span>
                </li>
            );
        })}
    </ol>
);
